import { sx } from '../sx';
import { MySignInPanel } from './DataMethod';

/** The executive's account page — just their own name and password. */
export function Account() {
  return (
    <div
      style={sx(
        'max-width:760px;margin:0 auto;padding:24px 16px 60px;display:flex;flex-direction:column;gap:16px',
      )}
    >
      <MySignInPanel />
    </div>
  );
}
